import {css} from "styled-components";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

const FormsCss = css`
  .btn-farmy {
    text-shadow: none;
    font-weight: 600;
    box-shadow: none;
    border: 1px solid;
    padding: 0.4em 0.5em;
    border-radius: 4px;
    
    &.btn-lg {
      font-size: 115%;
    }
    
    &.btn-round {
      border-radius: 10em;
    }
    
    &.btn-success, &.btn-green {
      background-color: ${theme.colors.farmy.green};
      color: white;
    }
    
    &.btn-default {
      color: ${theme.colors.farmy.green};
      border: 2px solid ${theme.colors.farmy.green};
      &:disabled {
        border-color: ${theme.colors.mutedBg};
        color: ${theme.colors.mutedBg};
      }
    }
    
    &.btn-orange {
      background-color: ${theme.colors.farmy.orange};
      color: white;
      
      &:disabled {
        background-color: ${theme.colors.farmy.lightgrey};
      }
    }
    
    &.btn-grey {
      background-color: ${theme.colors.farmy.lighterGrey};
      color: white;
    }
    
    &.btn-farmy-family {
      background-color: ${theme.colors.farmy.farmyFamilyBg};
      border-color: ${theme.colors.farmy.farmyFamilyBg};
      color: white;
    }
  }
  
  .active-shadow:active {
    box-shadow: 2px 2px 9px -4px rgba(0,0,0,0.4) inset;
  }
`;

export default FormsCss;
